import React, { useMemo } from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import OrderNew from '@components/shared/orders/OrderNew';
import PageHeader from '@shared/PageHeader';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useOrderItemColumns from '@hooks/operator/useOrderItemColumns';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

import { contactAddressService } from '@services/operator/contactAddressService';
import { orderService } from '@services/operator/orderService';
import bundleService from '@services/operator/bundleService';

const OperatorOrderNewForm = () => {
  const { merchantShippingTypes, merchantSalesChannels, merchantInventoryTypes, currencies, refreshMerchantSalesChannels, refreshMerchantShippingTypes } = useOperatorData();
  const { enabledColumns, availableColumns, updateColumns } = useOrderItemColumns();

  const productService = useOperatorProductService();

  const effectiveInventoryTypes = useMemo(() => {
    return (merchantInventoryTypes || []).map(mit => mit.inventory_type).filter(Boolean);
  }, [merchantInventoryTypes]);

  return (
    <div>
      <PageHeader items={['orders', 'orders.list', 'orders.new']} />
      <OrderNew
        orderService={orderService}
        productService={productService}
        contactAddressService={contactAddressService}
        role="operator"
        salesChannels={merchantSalesChannels}
        onReloadSalesChannels={refreshMerchantSalesChannels}
        shippingTypes={merchantShippingTypes}
        onReloadShippingTypes={refreshMerchantShippingTypes}
        inventoryTypes={effectiveInventoryTypes}
        currencies={currencies}
        merchantDataLoading={false}
        enabledOrderItemColumns={enabledColumns}
        availableOrderItemColumns={availableColumns}
        onUpdateOrderItemColumns={updateColumns}
        bundleService={bundleService}
      />
    </div>
  );
};

const OperatorOrderNew = () => {
  return (
    <MerchantSelect>
      <OperatorOrderNewForm />
    </MerchantSelect>
  );
};

export default OperatorOrderNew;
